import { AppAd } from "./ad";

export class AdMultiplex extends AppAd {
    constructor() {
        super({
            logLabel: 'AdMultiplex',
        });
    }

    buildHtml() {
        return `
            <ins class="adsbygoogle"
                style="display: block"
                data-ad-client="ca-pub-1557542376119618"
                data-ad-slot="${this.slotId}"
                data-ad-format="autorelaxed"
                ${this.lazyLoad ? 'data-loading="lazy"' : ''}>
            </ins>
        `;
    }
}
